import appGlobalScript from '/home/runner/work/monorepo/monorepo/packages/booking-tool/src/global/app.ts';
export const globalScripts = appGlobalScript;
